import { css } from 'lit';

export const leavePeriodStyles = css`
  div.leave:before,
  .item.leave a:before {
    background: hsl(130, 50%, 60%);
  }

  div.seminar:before,
  .item.seminar a:before {
    background: hsl(220, 50%, 60%);
  }

  div.jobTravel:before,
  .item.jobTravel a:before {
    background: hsl(257, 45%, 59%);
  }

  div.homeOffice:before,
  .item.homeOffice a:before {
    background: hsl(280, 100%, 77%);
  }

  div.sickLeave:before,
  .item.sickLeave a:before {
    background: hsl(324, 93%, 59%);
  }

  div.sickSelf:before,
  .item.sickSelf a:before {
    background: hsl(15, 95%, 49%);
  }

  div.sickChildren:before,
  .item.sickChildren a:before {
    background: hsl(31, 92%, 51%);
  }

  div.timeOff:before,
  .item.timeOff a:before {
    background: hsl(190, 50%, 60%);
  }

  div.vacation:before,
  .item.vacation a:before {
    background: hsl(80, 70%, 50%);
  }

  div.OTHER:before,
  .item.OTHER a:before {
    background: hsl(50, 80%, 60%);
  }

  .item.leave-period.unconfirmed a:after {
    content: '';
    background-image: url(/images/hatched.png);
    background-size: 30px 30px;
    background-repeat: no-repeat;
    display: block;
    position: absolute;
    flex: none;
    left: -30px;
    top: 6px;
    width: 18px;
    height: 18px;
  }
`;
